
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bootcamps",
      function () {
        return require("private-next-pages/bootcamps/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bootcamps"])
      });
    }
  